/**
 * @fileoverview Book a lesson (C6, decided Nov 1, 2026): a student's live
 * public booking pages, one per teacher (GET /student/booking-links), and how
 * each is offered. A page opens in a new tab; any payment happens there.
 */

import { useEffect, useState } from "react";
import { getBookingLinks } from "@/lib/studentApi";

/**
 * The student's booking links, read once while `enabled`.
 * @param {boolean} [enabled=true]
 * @returns {Array<{user_id:string, url:string, source:string, teacher_name?:string}>}
 */
export function useStudentBookingLinks(enabled = true) {
  const [links, setLinks] = useState([]);
  useEffect(() => {
    if (!enabled) return undefined;
    const controller = new AbortController();
    getBookingLinks({ signal: controller.signal })
      .then((found) => setLinks(found))
      .catch(() => {
        if (!controller.signal.aborted) setLinks([]);
      });
    return () => controller.abort();
  }, [enabled]);
  return links;
}

/** "Book a lesson", or "Book with Robin Vance" when there is more than one teacher to book. */
export const bookLabel = (link, many) => (many && link?.teacher_name ? `Book with ${link.teacher_name}` : "Book a lesson");

/** "Robin Vance’s booking page, in a new tab". */
export const bookHint = (link) =>
  link?.teacher_name ? `${link.teacher_name}’s booking page, in a new tab` : "Their booking page, in a new tab";
